import { setLocalStorageWithODTP } from '@/helpers';
import appEvents from '@/shared/appEvents';
import { setGAUserId } from '@/shared/ga';

import userSlice from './index';

export const setUserData = ({ _id: userId, ...rest }: Parameters<typeof userSlice.actions.setUserData>[0]) => {
  setGAUserId(userId);
  if (rest.subscriptionStatus?.features?.includes('explorer')) {
    setLocalStorageWithODTP(rest.subscriptionStatus);
  }
  return userSlice.actions.setUserData({ userId, ...rest });
};
setUserData.type = userSlice.actions.setUserData.type;

export const unsetUserData = () => {
  appEvents.emit('user:logout');
  return userSlice.actions.unsetUserData();
};
unsetUserData.type = userSlice.actions.unsetUserData.type;

export const {
  setSubscriptionData,
  // setUserData, // It is replaced by the wrapped version
  // unsetUserData, // It is replaced by the wrapped version
  setUserProfile,
  setSessionChecked,
  setSessionError,
  setIsRealEmail,
  setTermsAccepted,
  toggleFavoriteHabitat,
  setReferralData,
  setClipButtonClicked,
  updateUserProperty,
  updateABTestVariants,
} = userSlice.actions;
